<div class="m-base-select"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }">
    <div v-m-popup:popup
         class="m-base-select__popup">
        <slot :toggle="togglePopup"
              :key-up="onKeydownUp"
              :key-down="onKeydownDown"
              :key-tab="onKeydownTab"
              :key-esc="onKeydownEsc"
              :key-enter="onKeydownEnter"
              :key-space="onKeydownSpace"
              :key-home="onKeydownHome"
              :key-end="onKeydownEnd"
              :key-letter="onKeydownLetter"></slot>
    </div>

    <slot name="validation-message"></slot>

    <m-popup ref="popup"
             placement="bottom-start"
             :open.sync="internalOpen"
             :disabled="!active"
             :enter="transitionEnter"
             :leave="transitionLeave"
             :padding="false"
             :preload="true"
             :lazy="false"
             :focus-management="false"
             :close-on-backdrop="true"
             :open-trigger="'manual'"
             :sidebar-full-height="sidebarFullHeight"
             width="100%"
             @open="onOpen"
             @close="onClose">
        <template slot="header">
            <slot name="popup-header"
                  :key-up="onKeydownUp"
                  :key-down="onKeydownDown"
                  :key-tab="onKeydownTab"
                  :key-esc="onKeydownEsc"
                  :key-enter="onKeydownEnter"
                  :key-space="onKeydownSpace"
                  :key-home="onKeydownHome"
                  :key-end="onKeydownEnd"
                  :key-letter="onKeydownLetter">
            </slot>
        </template>

        <ul :id="ariaControls"
            class="m-base-select__list"
            ref="items"
            :aria-labelledby="controlId"
            aria-live="polite"
            :class="{ 'm--is-virutalScroll': virtualScroll }"
            :style="{ minWidth: inputMaxWidth, maxHeight: listMaxHeightProps }">

            <slot name="outer-items"
                  :items="items"
                  :get-item-props="getItemProps"
                  :get-item-handlers="getItemHandlers">
                <template v-for="(item, index) of items">
                    <m-select-item v-bind="getItemProps(item, index)"
                                   v-on="getItemHandlers(item, index)">
                        <slot name="items"
                              :item="item"
                              :index="index"><span v-html="item"></span></slot>
                    </m-select-item>
                </template>
            </slot>

        </ul>
    </m-popup>

</div>
